import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { SetTypeDialogData } from '@app/shared/components/dialogs/set-type-dialog/set-type-dialog.data';

@Component({
    selector : 'set-type-dialog',
    template: require('./set-type-dialog.component.html'),
    styles: [require('./set-type-dialog.component.scss')]
})
export class SetTypeDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: SetTypeDialogData) {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/set-type-dialog/set-type-dialog.component.ts